<template>

    <v-layout wrap>
        <v-flex xs12>
            <v-card flat color="grey lighten-4" class="kim-card">

                <v-list two-line subheader class="transparent">

                    <v-subheader>Resumen</v-subheader>

                    <v-list-tile
                        avatar
                    >
                        <v-list-tile-avatar>
                            <v-avatar color="grey ">
                                <v-icon color="white">fa-user-tie</v-icon>
                            </v-avatar>
                        </v-list-tile-avatar>

                        <v-list-tile-content>
                            <v-list-tile-title>{{ name }}</v-list-tile-title>
                            <v-list-tile-sub-title>Especialista</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action>
                            <template v-if="!individualProvider">
                                <v-btn class="mr-3" fab small dark color="secondary"
                                       @click="$emit('click:edit:specialist')">
                                    <v-icon>fa-pen</v-icon>
                                </v-btn>
                            </template>
                        </v-list-tile-action>

                    </v-list-tile>


                    <v-list-tile
                        avatar
                    >
                        <v-list-tile-avatar>
                            <v-avatar color="grey ">
                                <v-icon color="white">fa-calendar-alt</v-icon>
                            </v-avatar>
                        </v-list-tile-avatar>

                        <v-list-tile-content>
                            <v-list-tile-title>{{ date }}</v-list-tile-title>
                            <v-list-tile-sub-title>Fecha y Hora</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action>
                            <v-btn class="mr-3" fab small dark color="secondary" @click="$emit('click:edit:date')">
                                <v-icon>fa-pen</v-icon>
                            </v-btn>
                        </v-list-tile-action>
                    </v-list-tile>


                    <v-subheader v-if="internal || (!internal && vcAllowed)">Configuración</v-subheader>

                    <v-list-tile
                        avatar
                        v-if="internal"
                    >
                        <v-list-tile-avatar>
                            <v-avatar color="grey ">
                                <v-icon size="20" color="white">fa-coffee</v-icon>
                            </v-avatar>
                        </v-list-tile-avatar>

                        <v-list-tile-content>
                            <v-list-tile-title>Cita sin costo</v-list-tile-title>
                            <v-list-tile-sub-title>Ej. Para controles, ofertas, etc.</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action>
                            <v-switch
                                color="secondary"
                                v-model="free"/>
                        </v-list-tile-action>

                    </v-list-tile>


                    <v-list-tile
                        avatar
                        v-if="vcAllowed"
                    >
                        <v-list-tile-avatar>
                            <v-avatar color="grey ">
                                <v-icon size="20" color="white">fa-video</v-icon>
                            </v-avatar>
                        </v-list-tile-avatar>

                        <v-list-tile-content>
                            <v-list-tile-title>Cita por video</v-list-tile-title>
                            <v-list-tile-sub-title>Se enviará un link de videollamada</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action>
                            <v-switch
                                color="secondary"
                                v-model="vc"/>
                        </v-list-tile-action>

                    </v-list-tile>


                </v-list>

            </v-card>
        </v-flex>
    </v-layout>

</template>

<script>
import {mapState} from "vuex";

export default {
    props: {
        internal: {
            type: Boolean,
            default: false
        },
        individualProvider: {
            type: Boolean,
            default: false
        },
        event: {
            type: Object,
            required: true
        },
        schedule: {
            type: Object,
            required: true
        },
        vcAllowed: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            free: false,
            vc: false
        }
    },
    computed: {
        name() {
            var vm = this
            return vm.schedule.specialist && `${vm.schedule.specialist.first_name} ${vm.schedule.specialist.last_name}` ||
                `${vm.schedule.service_item.service.name} | ${vm.schedule.service_item.description}`
        },
        date() {
            var vm = this
            return `${vm.$moment(vm.event.date).format('ddd DD MMM').toUpperCase()} a las ${vm.event.time}`
        },
    },
    watch: {
        free(val) {
            this.$emit('change:free', val)
        },
        vc(val) {
            this.$emit('change:vc', val)
        }
    }
}
</script>